<template>
  <div class="printingsurfacematerial-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('printingsurfacematerial_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-checkerboard</v-icon>{{$t('profile.printingsurface.materials')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <PrintingSurfaceMaterialFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
@click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import PrintingSurfaceMaterialFilterForm from '../../components/printingsurfacematerial/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'PrintingSurfaceMaterialList',
  servicePrefix: 'PrintingSurfaceMaterial',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    PrintingSurfaceMaterialFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('profile.printingsurface.name'), value: 'name' },
        { text: this.$t('global.namefr'), value: 'namefr' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['name'], sortDesc : [false]}
    };
  },
  computed: {
    ...mapGetters('printingsurfacematerial', {
      items: 'list'
    }),
    ...mapFields('printingsurfacematerial', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('printingsurfacematerial', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
